import { render, staticRenderFns } from "./FeeReviewModal.vue?vue&type=template&id=6cd39d56"
import script from "./FeeReviewModal.vue?vue&type=script&lang=js"
export * from "./FeeReviewModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports